import { makeAutoObservable } from 'mobx';
import { OsiServiceCompaniesWidgetViewModel } from '@shared/types/mobx/widgets/OsiServiceCompaniesWidget';
import { OsiServiceCompany } from '@shared/types/osi/osiServiceCompanies';
import { inject, injectable } from 'inversify';
import { getServiceCompaniesByOsiId } from '@shared/api/osi/serviceCompanies';
import { notifications } from '@shared/utils/notifications';
import logger from 'js-logger';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';

@injectable()
export class OsiServiceCompaniesVm implements OsiServiceCompaniesWidgetViewModel {
  serviceCompanies: OsiServiceCompany[] = [];

  isLoading = false;

  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);

    this.loadServiceCompanies();
  }

  loadServiceCompanies = async () => {
    try {
      if (!this.osiModule?.osiId) return;
      this.isLoading = true;
      this.serviceCompanies = await getServiceCompaniesByOsiId(this.osiModule.osiId);
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };
}
